module.exports = __webpack_public_path__ + "static/media/CircleOfInfluenceConcern.aab6dc1c.png";